import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { motion } from 'framer-motion';
import { MessageSquare, Video, Palette, Settings, Rocket, Check } from 'lucide-react';

const content = {
  de: {
    label: 'UNSER BESTES PRODUKT',
    headline: 'WEBSITES & WEBAPPS SCHON IN 3 TAGEN ONLINE ZUM FESTPREIS',
    intro: 'Sie brauchen schnell eine professionelle Webseite oder WebApp, die modern aussieht, Vertrauen schafft und neue Kunden gewinnt? Wir bringen Ihr Projekt innerhalb kürzester Zeit online – klar strukturiert, mobil optimiert und zum transparenten Festpreis.',
    intro2: 'Ob einfache Unternehmenswebseite, Landingpage oder individuelle WebApp: Wir entwickeln eine digitale Lösung, die zu Ihrem Angebot, Ihrer Zielgruppe und Ihren Zielen passt.',
    ideal: 'Ideal für Selbstständige, lokale Unternehmen, Dienstleister, Start-ups und alle, die ohne lange Wartezeiten professionell im Web sichtbar werden möchten.',
    processLabel: 'SO EINFACH LÄUFT DER PROZESS AB',
    steps: [
      { title: 'Kontaktaufnahme', desc: 'Sie nehmen Kontakt mit uns auf und schildern kurz, was Sie benötigen.' },
      { title: 'Video-Meeting & Bedarfsklärung', desc: 'In einem kurzen Video-Meeting lernen wir uns kennen, besprechen Ihre Wünsche, Ziele und Vorstellungen.' },
      { title: 'Erstes Design innerhalb von 48h', desc: 'Innerhalb von 48 Stunden erhalten Sie den ersten Designentwurf Ihrer neuen Webseite oder WebApp.' },
      { title: 'Anpassungen & Änderungen', desc: 'Wir optimieren das Design und die Inhalte nach Ihrem Feedback, bis alles zu Ihrem Unternehmen passt.' },
      { title: 'Deployment – Sie sind online', desc: 'Nach der finalen Freigabe bringen wir Ihre Webseite oder WebApp online. Schnell, professionell und startklar.' }
    ],
    packagesLabel: 'UNSERE PAKETE',
    packages: [
      {
        name: 'Launch Starter',
        subtitle: 'Alles, was Sie brauchen, um professionell online zu sein.',
        ideal: 'Ideal für Selbstständige, kleine Unternehmen und Dienstleister, die schnell eine moderne Online-Präsenz benötigen.',
        features: ['Webseite mit bis zu 5 Sektionen', 'Modernes, responsives Design', 'Verknüpfung mit Social Media', 'Kontaktbereich', 'Rechtliche Seiten', 'Online innerhalb von 3 Tagen möglich'],
        price: '399,- €*',
        monthly: 'zzgl. Webhosting & Wartung: 29,- €/Monat'
      },
      {
        name: 'Business Connect',
        subtitle: 'Für alle, die nicht nur sichtbar sein, sondern Anfragen professionell verwalten möchten.',
        ideal: 'Perfekt für Unternehmen, die Kundenkontakte, Anfragen und Leads direkt über die Webseite organisieren wollen.',
        features: ['Alles aus dem Paket Launch Starter', 'Adminbereich für Kundenanfragen', 'Kontaktmanagement', 'Strukturierte Verwaltung eingehender Anfragen', 'Ideal für Dienstleister, Berater, Agenturen und lokale Unternehmen'],
        price: '699,- €*',
        monthly: 'zzgl. Webhosting & Wartung: 49,- €/Monat',
        featured: true
      },
      {
        name: 'Custom WebApp Pro',
        subtitle: 'Individuelle WebApps, maßgeschneidert auf Ihre Prozesse und Ziele.',
        ideal: 'Sie benötigen mehr als eine klassische Webseite? Wir entwickeln individuelle WebApps, Kundenportale, Buchungssysteme, Dashboards, interne Tools oder digitale Plattformen.',
        features: ['Kundenportale', 'Buchungs- und Anfrageplattformen', 'Interne Dashboards', 'Mitgliederbereiche', 'Automatisierte Workflows', 'Individuelle WebApps für Ihr Geschäftsmodell'],
        price: 'Auf Anfrage',
        monthly: 'Individuelles Angebot passend zu Ihrem Projektumfang'
      }
    ],
    footnote: '*Alle Preise inkl. gesetzlicher Mehrwertsteuer, sofern anwendbar.',
    cta: 'JETZT ANFRAGEN'
  },
  it: {
    label: 'IL NOSTRO MIGLIOR PRODOTTO',
    headline: 'SITI WEB & WEBAPP ONLINE IN SOLI 3 GIORNI A PREZZO FISSO',
    intro: 'Avete bisogno rapidamente di un sito web o webapp professionale, dal design moderno, che ispiri fiducia e acquisisca nuovi clienti? Portiamo il vostro progetto online in brevissimo tempo – strutturato, ottimizzato per mobile e a prezzo fisso trasparente.',
    intro2: 'Che si tratti di un semplice sito aziendale, landing page o webapp individuale: sviluppiamo una soluzione digitale adatta alla vostra offerta, al vostro target e ai vostri obiettivi.',
    ideal: 'Ideale per freelance, aziende locali, fornitori di servizi, start-up e tutti coloro che vogliono essere professionalmente visibili sul web senza lunghe attese.',
    processLabel: 'ECCO COME FUNZIONA IL PROCESSO',
    steps: [
      { title: 'Contatto', desc: 'Contattateci e descrivete brevemente ciò di cui avete bisogno.' },
      { title: 'Video-Meeting & Analisi', desc: 'In un breve video-meeting ci conosciamo, discutiamo i vostri desideri, obiettivi e idee.' },
      { title: 'Primo design entro 48 ore', desc: 'Entro 48 ore riceverete la prima bozza di design del vostro nuovo sito web o webapp.' },
      { title: 'Modifiche & Adattamenti', desc: 'Ottimizziamo il design e i contenuti in base al vostro feedback, fino a quando tutto si adatta alla vostra azienda.' },
      { title: 'Deployment – Siete online', desc: 'Dopo l\'approvazione finale, portiamo il vostro sito web o webapp online. Veloce, professionale e pronto.' }
    ],
    packagesLabel: 'I NOSTRI PACCHETTI',
    packages: [
      {
        name: 'Launch Starter',
        subtitle: 'Tutto ciò di cui avete bisogno per essere professionalmente online.',
        ideal: 'Ideale per freelance, piccole aziende e fornitori di servizi che necessitano rapidamente di una presenza online moderna.',
        features: ['Sito web con fino a 5 sezioni', 'Design moderno e responsive', 'Collegamento con social media', 'Area contatti', 'Pagine legali', 'Online entro 3 giorni possibile'],
        price: '399,- €*',
        monthly: 'più hosting & manutenzione: 29,- €/mese'
      },
      {
        name: 'Business Connect',
        subtitle: 'Per chi vuole non solo essere visibile, ma gestire le richieste in modo professionale.',
        ideal: 'Perfetto per aziende che vogliono organizzare contatti, richieste e lead direttamente tramite il sito web.',
        features: ['Tutto dal pacchetto Launch Starter', 'Area admin per richieste clienti', 'Gestione contatti', 'Gestione strutturata delle richieste', 'Ideale per consulenti, agenzie e aziende locali'],
        price: '699,- €*',
        monthly: 'più hosting & manutenzione: 49,- €/mese',
        featured: true
      },
      {
        name: 'Custom WebApp Pro',
        subtitle: 'WebApp individuali, su misura per i vostri processi e obiettivi.',
        ideal: 'Avete bisogno di più di un classico sito web? Sviluppiamo webapp individuali, portali clienti, sistemi di prenotazione, dashboard e piattaforme digitali.',
        features: ['Portali clienti', 'Piattaforme di prenotazione e richiesta', 'Dashboard interni', 'Aree membri', 'Workflow automatizzati', 'WebApp individuali per il vostro modello di business'],
        price: 'Su richiesta',
        monthly: 'Preventivo individuale in base alla portata del progetto'
      }
    ],
    footnote: '*Tutti i prezzi IVA inclusa, ove applicabile.',
    cta: 'RICHIEDI ORA'
  }
};

const stepIcons = [MessageSquare, Video, Palette, Settings, Rocket];

export default function ProductSection() {
  const { lang } = useLanguage();
  const t = content[lang];

  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="product" data-testid="product-section" className="relative py-24 md:py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-white" />
      <div
        className="absolute top-0 right-0 w-[40%] h-full bg-enbi-gold/[0.04]"
        style={{ clipPath: 'polygon(30% 0, 100% 0, 100% 100%, 0 100%)' }}
      />

      <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-6 md:px-12 lg:px-24">
        {/* Header with image */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
            {/* Left: Text */}
            <div className="lg:col-span-7">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-10 h-[2px] bg-enbi-gold" />
                <span className="text-enbi-gold text-xs tracking-[0.3em] uppercase font-semibold">{t.label}</span>
              </div>
              <h2 className="font-outfit text-2xl sm:text-3xl lg:text-4xl font-semibold text-enbi-navy uppercase tracking-tight mb-6 max-w-3xl">
                {t.headline}
              </h2>
              <p className="text-slate-600 text-base leading-relaxed mb-4">{t.intro}</p>
              <p className="text-slate-600 text-base leading-relaxed mb-4">{t.intro2}</p>
              <p className="text-slate-500 text-sm italic">{t.ideal}</p>
            </div>

            {/* Right: Image with diagonal clip */}
            <div className="lg:col-span-5">
              <div className="relative">
                <div
                  className="overflow-hidden"
                  style={{ clipPath: 'polygon(10% 0, 100% 0, 100% 100%, 0 90%)' }}
                >
                  <img
                    src="https://images.unsplash.com/photo-1758691737138-7b9b1884b1db?w=800&q=80"
                    alt="Happy business owners with new website"
                    className="w-full h-[400px] object-cover"
                  />
                </div>
                <div className="absolute -bottom-3 -left-3 w-20 h-20 bg-enbi-gold/20" />
                <div className="absolute -bottom-1.5 -left-1.5 w-20 h-20 border-2 border-enbi-gold" />
              </div>
            </div>
          </div>
        </motion.div>

        {/* Process Steps */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="mb-20"
        >
          <h3 className="font-outfit text-enbi-navy text-lg sm:text-xl uppercase tracking-tight font-semibold mb-10">
            {t.processLabel}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
            {t.steps.map((step, i) => {
              const Icon = stepIcons[i];
              return (
                <div key={i} className="relative" data-testid={`process-step-${i}`}>
                  <div className="flex md:flex-col items-start gap-4">
                    <div className="flex-shrink-0 w-12 h-12 bg-enbi-navy flex items-center justify-center">
                      <Icon className="text-enbi-gold" size={20} strokeWidth={1.25} />
                    </div>
                    <div>
                      <span className="text-enbi-gold text-[10px] tracking-wider font-bold">{String(i + 1).padStart(2, '0')}</span>
                      <h4 className="font-outfit text-enbi-navy text-sm font-semibold uppercase tracking-tight mt-1 mb-2">{step.title}</h4>
                      <p className="text-slate-500 text-xs leading-relaxed">{step.desc}</p>
                    </div>
                  </div>
                  {i < 4 && <div className="hidden md:block absolute top-6 left-[calc(100%+4px)] w-[calc(100%-56px)] h-[1px] bg-enbi-gold/30" />}
                </div>
              );
            })}
          </div>
        </motion.div>

        {/* Packages */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <h3 className="font-outfit text-enbi-navy text-lg sm:text-xl uppercase tracking-tight font-semibold mb-10">
            {t.packagesLabel}
          </h3>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {t.packages.map((pkg, i) => (
              <div
                key={i}
                data-testid={`package-card-${i}`}
                className={`relative border p-8 transition-all duration-500 hover:shadow-xl flex flex-col ${
                  pkg.featured
                    ? 'border-enbi-gold bg-enbi-navy text-white'
                    : 'border-slate-200 bg-white hover:border-enbi-gold/40'
                }`}
              >
                {pkg.featured && (
                  <div className="absolute -top-[1px] left-0 right-0 h-1 bg-enbi-gold" />
                )}
                <h4 className={`font-outfit text-lg font-bold uppercase tracking-tight mb-2 ${pkg.featured ? 'text-enbi-gold' : 'text-enbi-navy'}`}>
                  {pkg.name}
                </h4>
                <p className={`text-sm mb-3 ${pkg.featured ? 'text-white/70' : 'text-slate-600'}`}>
                  {pkg.subtitle}
                </p>
                <p className={`text-xs leading-relaxed mb-6 ${pkg.featured ? 'text-white/50' : 'text-slate-400'}`}>
                  {pkg.ideal}
                </p>
                <div className="space-y-2.5 mb-8 flex-1">
                  {pkg.features.map((f, j) => (
                    <div key={j} className="flex items-start gap-2.5">
                      <Check className={`flex-shrink-0 mt-0.5 ${pkg.featured ? 'text-enbi-gold' : 'text-enbi-gold'}`} size={14} strokeWidth={2} />
                      <span className={`text-sm ${pkg.featured ? 'text-white/80' : 'text-slate-600'}`}>{f}</span>
                    </div>
                  ))}
                </div>
                <div className="mt-auto">
                  <div className={`font-outfit text-2xl font-bold mb-1 ${pkg.featured ? 'text-white' : 'text-enbi-navy'}`}>
                    {pkg.price}
                  </div>
                  <p className={`text-xs mb-6 ${pkg.featured ? 'text-white/40' : 'text-slate-400'}`}>
                    {pkg.monthly}
                  </p>
                  <button
                    onClick={scrollToContact}
                    className={`w-full py-3.5 text-[11px] tracking-[0.15em] uppercase font-bold transition-all duration-300 ${
                      pkg.featured
                        ? 'bg-enbi-gold text-enbi-navy hover:bg-enbi-gold-light'
                        : 'border border-enbi-navy text-enbi-navy hover:bg-enbi-navy hover:text-white'
                    }`}
                  >
                    {t.cta}
                  </button>
                </div>
              </div>
            ))}
          </div>
          <p className="text-slate-400 text-xs mt-6">{t.footnote}</p>
        </motion.div>
      </div>
    </section>
  );
}
